import industrialPremisesFilters from '@/app/dashboard/industrial-premises/filters';
import { StatusBadge } from '@/components/ui/statusBadge';
import { cn } from '@/lib/cn';
import { toReadableAddress, toSqm } from '@/lib/utils';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  IndustrialPremisesConfig,
  type IndustrialPremises,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const IndustrialPremisesItem: RelationFieldProps<IndustrialPremises> = {
  nested: getRelationFieldNames(IndustrialPremisesConfig),
  filters: industrialPremisesFilters,
  renderItem: (item, isRelationField) => ({
    title:
      item.landlordCustomId ??
      item.customId ??
      item?.popularName ??
      'Ingen namn angivet',
    badge: <StatusBadge type='object' status={item.status} />,
    descriptionItems: (
      <div
        className={cn(
          isRelationField ? 'grid w-full' : 'flex flex-wrap items-center'
        )}
      >
        <span className='font-medium'>
          {item.address
            ? toReadableAddress(item.address, true, false)
            : 'Ingen adress angiven'}
        </span>

        {!isRelationField && <Dot />}
        <div
          className={cn(
            'flex items-center',
            isRelationField && 'w-full justify-between'
          )}
        >
          <span className='text-xs'>
            {' '}
            {IndustrialPremisesConfig.fields.category.choices?.find(
              (c) => c.v == item.category
            )?.d ?? 'Ingen kategori angiven'}
          </span>
          {!isRelationField && <Dot />}
          <span>
            {item.usableArea ? toSqm(item.usableArea) : 'Ingen area angiven'}
          </span>
        </div>
      </div>
    ),
  }),
};
